import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AgregarInventarioPage } from './agregar-inventario.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { SimpleMaskModule } from 'ngx-ion-simple-mask'


const routes: Routes = [
  {
    path: '',
    component: AgregarInventarioPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SimpleMaskModule,
    RouterModule.forChild(routes)
  ],
  providers:[Geolocation],

  declarations: [AgregarInventarioPage]
})
export class AgregarInventarioPageModule {}
